import { render } from "./OurAlumnai.vue?vue&type=template&id=51015289"
import script from "./OurAlumnai.vue?vue&type=script&lang=js"
export * from "./OurAlumnai.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__